import { XIcon } from "lucide-react";
import { useTranslation } from "../../i18n";
import { cn } from "../../utils";
import { IconButton } from "../Button/IconButton";
import { Tooltip } from "../Tooltip";
import { Text } from "../Typography";
import { useModalContext } from "./context";
import { ModalHeaderBaseProps } from "./types";

type Props = ModalHeaderBaseProps & {
  className?: string;
};

export const ModalHeader = (props: Props) => {
  const context = useModalContext();
  const { t } = useTranslation();

  const title = props.title ?? context.title;
  const description = props.description ?? context.description;
  const showClose = props.showClose ?? context.showClose ?? true;
  const className = props.className ?? context.headerClassName;
  const { titleId, descriptionId } = context;

  const showCloseButton = showClose && !context.preventClose;

  return (
    <header
      data-modal-header
      className={cn(
        "relative p-4 flex items-center justify-between border-b border-neutral-500/10",
        className,
      )}
    >
      <div
        className={cn("flex flex-col gap-1 w-full", showCloseButton && "pe-8")}
      >
        {title && (
          <Text as="h3" id={titleId} size="md" weight="medium">
            {title}
          </Text>
        )}
        {description && (
          <Text id={descriptionId} size="sm" className="text-neutral-500/50">
            {description}
          </Text>
        )}
      </div>
      {showCloseButton && (
        <Tooltip content={t("modal.closeLabel")} placement="bottom-end">
          <IconButton
            className="absolute top-1.5 end-1.5"
            variant="ghost"
            color="neutral"
            size="md"
            onClick={context.handleDismiss}
            aria-label={t("modal.closeLabel")}
          >
            <XIcon />
          </IconButton>
        </Tooltip>
      )}
    </header>
  );
};
